import { faFilter, faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Nav, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { getAllProducts, getOnlyProducts } from "../../features/products/productsSlice";
import { variant_type } from "../../utils/common";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Category_Subcategory_Card from "../common-components/category_subcategory_card/Category_Subcategory_Card";
import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";
import "./Categories.css";
import FilterComponent from "../common-components/filter_component/FilterComponent";
import {
  getColours,
  getPolish,
  getSizes,
} from "../../features/colour/colourSlice";

import {
  getAllCategories,
  getAllSubCategory,
} from "../../features/master/masterSlice";
import Green_round_btn from "../common-components/common_btn/green_round_btn/Green_round_btn";

const STEP = 4;

function Categories() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("category_id");
  const subCategoryId = searchParams.get("sub_category_id");

  const dispatch = useDispatch();
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Categories", link: "", isActive: true },
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const [visibleCounts, setVisibleCounts] = useState([]);

  // Scroll to a specific category section when "See Less" is clicked
  const handleToggle = (index, totalProducts, categoryId) => {
    setVisibleCounts((prevCounts) => {
      const newCounts = prevCounts.map((count, i) =>
        i === index
          ? count >= totalProducts
            ? STEP
            : Math.min(count + STEP, totalProducts)
          : count,
      );

      // Scroll if reducing to STEP
      if (prevCounts[index] >= totalProducts) {
        const el = document.getElementById(categoryId);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 100); // delay to ensure layout update
        }
      }

      return newCounts;
    });
  };

  // const location = useLocation();

  const productData = useSelector((state) => state.product.onlyProducts);
  const products = productData?.products || [];
  const categories = useSelector((state) => state.master.categories);
  const allsubcategory = useSelector((state) => state.master.subcategories);

  useEffect(() => {
    dispatch(getAllSubCategory({ category_id: selectedCategoryId }));
  }, [dispatch, selectedCategoryId]);

  const earringStyles = productData?.earringStyles || [];
  const necklaceStyles = productData?.necklaceStyles || [];
  const occasions = productData?.occasions || [];
  const designShapes = productData?.designShapes || [];

  const colours = useSelector((state) => state.colours.colour.data || []);
  const sizes = useSelector((state) => state.colours.size.data || []);
  const polishes = useSelector((state) => state.colours.polish.data || []);

  const defaultFilters = {
    category: [],
    subCategory: [],
    colors: [],
    sizes: [],
    polish: [],
    earringStyle: [],
    necklaceStyle: [],
    occasions: [],
    designShapes: [],
    priceRange: 20000,
  };

  const [filters, setFilters] = useState();

  const updateFilter = (key, value) => {
    setFilters((prev) => {
      const updated = {
        ...prev,
        [key]: value,
      };

      return updated;
    });
  };

  // useEffect(() => {
  //   sessionStorage.setItem("shopFilters", JSON.stringify(filters));
  // }, [filters]);

  useEffect(() => {
    dispatch(getColours());
    dispatch(getSizes());
    dispatch(getPolish());
    dispatch(getAllCategories());
  }, [dispatch]);

  // useEffect(() => {
  //   if (!categories.length) return;
  //   setCurrentPage(1);
  //   const firstCategory = categoryId || categories[0].id;
  //   setSelectedCategoryId(firstCategory);
  //   dispatch(getAllSubCategory({ category_id: firstCategory }));
  // }, [categories]);

  useEffect(() => {
    if (!categories.length) return;

    setCurrentPage(1);

    const randomIndex = Math.floor(Math.random() * categories.length);
    const randomCategory = categories[randomIndex];

    setSelectedCategoryId(randomCategory.id);
    dispatch(getAllSubCategory({ category_id: randomCategory.id }));
  }, [categories]);

  useEffect(() => {
    if (!allsubcategory.length || !selectedCategoryId) return;
    setCurrentPage(1);
    const firstSubCategory = allsubcategory[0].id;

    setSelectedSubCategoryId(firstSubCategory);

    setFilters((prev) => ({
      ...prev,
      category: [Number(selectedCategoryId)],
      subCategory: [Number(firstSubCategory)],
    }));

    const params = new URLSearchParams(window.location.search);
    params.set("category_id", selectedCategoryId);
    params.set("sub_category_id", firstSubCategory);

    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`,
    );
  }, [allsubcategory, selectedCategoryId]);

  useEffect(() => {
    const scrollToId = location.state?.scrollToId;
    if (scrollToId) {
      const scroll = () => {
        const element = document.getElementById(scrollToId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          setTimeout(scroll, 100);
        }
      };
      scroll();
    }
  }, [location.state]);

  const [childList, setChildList] = useState([]);
  const [childStatus, setChildStatus] = useState(""); // noChild
  const productSectionRef = useRef(null);
  const shouldScroll = useRef(false);

  const handleCategoryClick = (categoryId) => {
    shouldScroll.current = true;

    setSelectedCategoryId(categoryId);
    setCurrentPage(1);
    setSelectedSubCategoryId(null);

    setFilters((prev) => ({
      ...prev,
      category: [categoryId],
      subCategory: [],
    }));

    const params = new URLSearchParams(window.location.search);
    params.set("category_id", categoryId);
    params.delete("sub_category_id");

    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`,
    );
    navigate(`/shops?category_id=${categoryId}`);
  };

  useEffect(() => {
    if (
      shouldScroll.current &&
      products.length > 0 &&
      productSectionRef.current
    ) {
      shouldScroll.current = false;

      window.scrollTo({
        top: productSectionRef.current.offsetTop - 20,
        behavior: "smooth",
      });
    }
  }, [products]);

  // const handleCategoryClick = (categoryId) => {
  //   navigate("/shops", {
  //     state: {
  //       category_id: categoryId,
  //     },
  //   });
  // };

  const handleSubCategoryClick = (subId) => {
    setSelectedSubCategoryId(Number(subId));
    setCurrentPage(1);
    setFilters((prev) => ({
      ...prev,
      category: [Number(selectedCategoryId)],
      subCategory: [Number(subId)],
    }));

    const params = new URLSearchParams(window.location.search);
    params.set("category_id", Number(selectedCategoryId));
    params.set("sub_category_id", Number(subId));

    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`,
    );
  };

  const [status, setStatus] = useState("");

  const [showFilter, setShowFilter] = useState(false);

  // SEARCH STATE
  const [searchTerm, setSearchTerm] = useState("");

  // SORT STATE
  const [sortType, setSortType] = useState("default");

  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);
  const totalPages = useSelector((state) => state.product.total_pages) || 1;
  useEffect(() => {
    if (
      filters &&
      filters?.category?.length > 0 &&
      filters?.subCategory?.length > 0
    ) {
      dispatch(
        getOnlyProducts({
          page: currentPage,
          per_page: 8,
          category_id: filters.category.join(","),
          sub_category_id: filters.subCategory.join(","),
          // colour_id: filters.colors.join(","),
          // polish_id: filters.polish.join(","),
          // size_id: filters.sizes.join(","),
          // earring_style: filters.earringStyle.join(","),
          // necklace_style: filters.necklaceStyle.join(","),
          // occasion: filters.occasions.join(","),
          // design_shape: filters.designShapes.join(","),
          // max_price: filters.priceRange,
          // sortBy: sortType,
          // name: searchTerm,
        }),
      );
    }
  }, [dispatch, filters, searchTerm, sortType]);

  // const isFetching = useRef(false);
  // const loading = useSelector((state) => state.product.loading);
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollTop =
  //       window.pageYOffset || document.documentElement.scrollTop;

  //     const windowHeight = window.innerHeight;
  //     const fullHeight = document.documentElement.offsetHeight;

  //     if (
  //       scrollTop + windowHeight >= fullHeight - 300 &&
  //       !loading &&
  //       currentPage < totalPages
  //     ) {
  //       setCurrentPage((prev) => prev + 1);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [loading, currentPage, totalPages]);

  // useEffect(() => {
  //   if (!loading) {
  //     isFetching.current = false;
  //   }
  // }, [loading]);

  return (
    <section className="Categories_section_holder">
      <div className="container-fluid">
        <div className="Categories">
          <Breadcrumb_comp breadcrumbs={breadcrumbs} />

          {/* new code for subcategories */}

          {/* <div className="mobile_filter_btn">
            <button onClick={handleShow} className="filter_btn">
              <FontAwesomeIcon icon={faFilter} style={{ color: "#840101" }} />{" "}
              <span>Filters</span>
            </button>

            <button onClick={handleShow} className="filter_btn ms-2">
              <FontAwesomeIcon icon={faSort} style={{ color: "#840101" }} />{" "}
              <span>Sort</span>
            </button>
          </div> */}
          <div className="heading_holder">
            <h4 className="heading_text">Explore Collection</h4>
          </div>

          <div className="cat_subcat_div">
            {status === "noCategory" ? (
              <p className="text-danger">No category available.</p>
            ) : (
              <div variant="pills" className="flex-row p-0 mb-3">
                <Swiper
                  className="mySwiper "
                  onSwiper={(swiper) => setSwiperInstance(swiper)}
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  modules={[Pagination, Navigation]}
                  breakpoints={{
                    0: { slidesPerView: 2, spaceBetween: 10 },
                    486: { slidesPerView: 2.5, spaceBetween: 10 },
                    576: { slidesPerView: 3, spaceBetween: 10 },
                    768: { slidesPerView: 3, spaceBetween: 10 },
                    992: { slidesPerView: 4, spaceBetween: 10 },
                    1200: { slidesPerView: 5, spaceBetween: 10 },
                    1400: { slidesPerView: 6, spaceBetween: 10 },
                    1800: { slidesPerView: 7, spaceBetween: 10 },
                  }}
                >
                  {categories?.map((slide, index) => (
                    <SwiperSlide key={index} className="product-slide">
                      <Nav.Item>
                        <Nav.Link
                          eventKey={slide?.id}
                          className={
                            filters?.category?.includes(slide.id)
                              ? "activecategory"
                              : ""
                          }
                          onClick={() => {
                            handleCategoryClick(slide?.id);
                          }}
                        >
                          <Category_Subcategory_Card
                            className="product-image"
                            content={slide?.name}
                            catDiscount={slide?.cat_discount}
                            image={
                              slide?.image
                                ? slide.image.startsWith("http")
                                  ? slide.image
                                  : process.env.REACT_APP_IMG_URL + slide.image
                                : "/assets/images/common alex jewellery.png"
                            }
                            imgClassName="category-image"
                          />
                          <div className="triangle-right"></div>
                        </Nav.Link>
                      </Nav.Item>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}
          </div>

          {categories?.length === 0 ? (
            <p className="text-danger">
              No subcategory available for this category.
            </p>
          ) : (
            <>
              <div className="subcat_div">
                <div className="heading_holder">
                  <h4 className="heading_text">Shop By Category</h4>
                </div>
                <div variant="pills" className="flex-row p-0  mb-3">
                  <Swiper
                    className="mySwiper"
                    onSwiper={(swiper) => setSwiperInstance(swiper)}
                    pagination={{
                      dynamicBullets: true,
                      clickable: true,
                    }}
                    modules={[Pagination, Navigation]}
                    breakpoints={{
                      0: { slidesPerView: 2, spaceBetween: 10 },
                      486: { slidesPerView: 2.5, spaceBetween: 10 },
                      576: { slidesPerView: 3, spaceBetween: 10 },
                      768: { slidesPerView: 3, spaceBetween: 10 },
                      992: { slidesPerView: 4, spaceBetween: 10 },
                      1200: { slidesPerView: 5, spaceBetween: 10 },
                      1400: { slidesPerView: 6, spaceBetween: 10 },
                      1800: { slidesPerView: 7, spaceBetween: 10 },
                    }}
                  >
                    {allsubcategory?.length > 0 &&
                      allsubcategory.map((slide, index) => (
                        <SwiperSlide key={index} className="product-slide">
                          <Nav.Item>
                            <Nav.Link
                              eventKey={slide?.id}
                              className={
                                filters?.subCategory?.includes(slide.id)
                                  ? "activecategory"
                                  : ""
                              }
                              onClick={() => handleSubCategoryClick(slide?.id)}
                            >
                              <Category_Subcategory_Card
                                className="product-image second-swiper-product-image"
                                content={slide?.name}
                                image={
                                  slide?.image
                                    ? slide.image.startsWith("http")
                                      ? slide.image
                                      : process.env.REACT_APP_IMG_URL +
                                        slide.image
                                    : "/assets/images/common alex jewellery.png"
                                }
                                catDiscount={slide?.cat_discount}
                                imgClassName="category-image"
                              />
                              <div className="triangle-right"></div>
                            </Nav.Link>
                          </Nav.Item>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </div>
            </>
          )}

          {products?.length === 0 ? (
            <p className="text-danger">
              No products available for this selection.
            </p>
          ) : (
            <div ref={productSectionRef} className="subcat_div">
              <div className="heading_holder">
                <h4 className="heading_text">Products</h4>
              </div>

              <div className="row">
                {products?.map((product, index) => {
                  let metal;
                  let size;
                  let triple;
                  if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    metal = product?.Product_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                    triple = size?.Triple_Variants?.[0];
                  }

                  const activeVariant = triple || size || metal;

                  return (
                    <div
                      className="col-lg-4 col-md-4 col-sm-6 col-6 px-md-2 px-1 custom_5_col"
                      key={product?.id || index}
                    >
                      <Product_Info_Card
                        product={product}
                        id={product?.id}
                        imgSrc={product?.image}
                        vdoSrc={product?.image}
                        productName={product?.name}
                        prodDiscount={product?.prod_discount}
                        productDesignId={product?.design_id}
                        priceText={product?.Product_Variants?.[0].price || 0}
                        mrp={product?.Product_Variants?.[0].mrp}
                        savingPrice={
                          parseFloat(product?.Product_Variants?.[0].mrp || 0) -
                          parseFloat(product?.Product_Variants?.[0].price || 0)
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* MOBILE FILTER OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        className="filter_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <FilterComponent
            filters={filters}
            updateFilter={updateFilter}
            categories={categories}
            subCategories={allsubcategory}
            colours={colours}
            sizes={sizes}
            polishes={polishes}
            earringStyles={earringStyles}
            necklaceStyles={necklaceStyles}
            occasions={occasions}
            designShapes={designShapes}
          />
        </Offcanvas.Body>
        <div className="offcanvas-footer">
          <div className="d-flex gap-3 justify-content-center">
            <div className="filter-btn">
              <Green_round_btn btnText="Clear" />
            </div>

            <div className="filter-btn">
              <Green_round_btn btnText="Apply" />
            </div>
          </div>
        </div>
      </Offcanvas>
    </section>
  );
}

export default Categories;
